export const catalog = {
  catalogSearchInputPlaceholderTitle: 'Suchen',
  catalogHeaderTitle: 'Details',
  catalogDetailsCurtainCopyOptionTitle: 'Link kopieren',
  catalogDetailsLinkCopiedAlertText: 'Link kopiert!',
  catalogDetailsCurtainFlagOptionTitle: 'Melden',
  catalogDetailsFlagCurtainTitle: 'Melden',
  catalogReportedCurtainContent: 'Inhalt gemeldet',
  catalogWantBuy: 'Möchtest {item} von {app} kaufen',
  catalogInterestedIn: '{link}'
}
